"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "canale-d-agordo": {
    "6fbddeed": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "campion": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c2df5fb": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "casate": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cfe8400a": [{
      "hkey": "2241ff17",
      "slug": "gares",
      "name": "Gares",
      "primary": true,
      "skipSearch": false
    }],
    "gaier": [{
      "hkey": "2241ff17",
      "slug": "gares",
      "name": "Gares",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9dc4fa06": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "la-mora": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c4f7dee": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "palafachina": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58bc27bb": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "skipSearch": false
    }],
    "val": [{
      "hkey": "f27f02e3",
      "slug": "canale-d-agordo",
      "name": "Canale d'Agordo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;